import { IllegalArgumentError } from 'faro-common-model';
import { sortableEntitySchema } from './sortable-entity.js';
import { StudyEntityType } from './study-entity-type.js';
import { z } from 'zod';
import { uuidish } from '../utils/uuidish.js';
import { nullishToUndefined } from '../utils/nullishToUndefined.js';
export const allocationRuleNotesMaxLength = 250;
export const allocationRuleMaximumQuantitativeValue = 100000000;
export const operatorTypeSchema = z.enum(['equality', 'range', 'custom']);
export const quantitativeOperatorSchema = z.enum(['<', '<=', '>', '>=', '=']);
export const quantitativeSchema = z.object({
    value: z.number().max(allocationRuleMaximumQuantitativeValue),
    operator: quantitativeOperatorSchema,
});
export const allocationRuleSchema = z.object({
    ...sortableEntitySchema.shape,
    entityType: z.literal(StudyEntityType.AllocationRule).default(StudyEntityType.AllocationRule),
    schemaId: uuidish,
    parentId: uuidish,
    value: z.string().nullish().transform(nullishToUndefined).optional(),
    operatorType: operatorTypeSchema.nullish().transform(nullishToUndefined).optional(),
    from: quantitativeSchema.nullish().transform(nullishToUndefined).optional(),
    to: quantitativeSchema.nullish().transform(nullishToUndefined).optional(),
    notes: z.string().max(allocationRuleNotesMaxLength).nullish().transform(nullishToUndefined).optional(),
});
export function toAllocationRule(allocationRule) {
    const result = allocationRuleSchema.safeParse(allocationRule);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid AllocationRule object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=allocation-rule.js.map